module.exports = __webpack_public_path__ + "static/blog-kubernetes-audit-events-ad0d8d719d1f114e68e04183747e64df.jpeg";